import { Button } from "@libertify/ui";
import { Flex, Input, Spin, Typography } from "antd";
import { useState } from "react";
import { useInsightComments } from "../../hooks/useInsightComments";
import { useTranslate } from "#src/hooks";
import { InsightCommentsList } from "./InsightCommentsList";

export type CommentSectionProps = {
  insightId: string;
  organizationId: string;
  projectId?: string;
};

export const InsightCommentSection = ({
  insightId,
  organizationId,
  projectId,
}: CommentSectionProps) => {
  const t = useTranslate();
  const [commentText, setCommentText] = useState("");

  const {
    comments,
    isLoading: commentsLoading,
    isPosting,
    isRemoving,
    addComment,
    editComment,
    removeComment,
  } = useInsightComments(organizationId, insightId, projectId);

  const handleAddComment = () => {
    if (!commentText.trim()) return;
    addComment(commentText.trim(), () => setCommentText(""));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleAddComment();
    }
  };
  return (
    <Flex vertical gap={12}>
      <Typography.Text
        strong
        style={{ textTransform: "uppercase", fontSize: 12 }}
      >
        {t("media.analytics.insights.commentsCount", {
          count: comments.length,
        })}
      </Typography.Text>

      {commentsLoading ? (
        <Flex justify="center" style={{ padding: "12px 0" }}>
          <Spin size="small" />
        </Flex>
      ) : (
        <InsightCommentsList
          comments={comments}
          isRemoving={isRemoving}
          editComment={editComment}
          removeComment={removeComment}
        />
      )}

      <Flex gap={8}>
        <Input.TextArea
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t("media.analytics.insights.commentPlaceholder")}
          autoSize={{ minRows: 2, maxRows: 4 }}
          style={{ flex: 1 }}
        />
        <Button
          disabled={!commentText.trim()}
          loading={isPosting}
          onClick={handleAddComment}
          style={{ alignSelf: "flex-end" }}
        >
          {t("media.analytics.insights.addComment")}
        </Button>
      </Flex>
    </Flex>
  );
};
